import ClassicExtension from "./ClassicExtension";

export default class TooltipExtension extends ClassicExtension {

    protected init($root): void {
        $root.find('[data-bs-toggle="tooltip"], [data-toggle="tooltip"], [data-tooltip], .bs-tooltip[title]')
            .each((i, el) => {
                const $el = $(el);

                const hideTimeout = Number($el.data('bs-hide-timeout'));
                if (hideTimeout) {
                    this.applyHideTimeout($el, hideTimeout);
                }

                this.removeOnIfElementRemoved($el);
            })
            .tooltip();
    }

    /**
     * Hide tooltip after data-bs-hide-timeout milliseconds
     */
    private applyHideTimeout($tooltip: JQuery, hideTimeout: number): void {
        let timeout = 0;

        $tooltip.on('shown.bs.tooltip', () => {

            if (hideTimeout) {
                timeout = window.setTimeout(() => $tooltip.tooltip('hide'), hideTimeout);
            }
        });

        $tooltip.on('hidden.bs.tooltip', () => {
            window.clearTimeout(timeout);
        });
    }


    /**
     * Destroy tooltip with when tooltiped element is destroyed
     */
    private removeOnIfElementRemoved($tooltip: JQuery): void {
        let interval = 0;

        $tooltip.on('shown.bs.tooltip', () => {
            interval = window.setInterval(() => {
                if (!$tooltip.get(0)?.isConnected) {
                    $tooltip.tooltip('dispose');
                    window.clearInterval(interval);
                }
            }, 500);

        });

        $tooltip.on('hidden.bs.tooltip', () => {
            window.clearInterval(interval);
        });

    }
}
